/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import { OrderState } from '../types';
import { MerchantTrackingDto } from './merchant-tracking-dto';
import { CurrencyValue } from './currency-value';
import { DeliveryAddress } from './delivery-address';
import { PointOnMap } from './point-on-map';
import { TimeItem } from './time-item';

export class OrderTracking {
  dropOffAddress: DeliveryAddress = new DeliveryAddress();
  merchant: MerchantTrackingDto;
  number: string;
  pickUpGeoPoint: PointOnMap = new PointOnMap();
  pickUpAddress: DeliveryAddress = new DeliveryAddress();
  placementDate: number;
  state: OrderState;
  totalCost: CurrencyValue = new CurrencyValue();
  trackingNumber: string;
  updateStateDate: number;
  timeline: TimeItem[]
}



// WEBPACK FOOTER //
// ./src/app/models/order-tracking.ts